import { render, staticRenderFns } from "./huosunshangchuan.vue?vue&type=template&id=070cf6e0&scoped=true&"
import script from "./huosunshangchuan.vue?vue&type=script&lang=js&"
export * from "./huosunshangchuan.vue?vue&type=script&lang=js&"
import style0 from "./huosunshangchuan.vue?vue&type=style&index=0&id=070cf6e0&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "070cf6e0",
  null
  
)

export default component.exports